import { Blank, Div, EvButton, Font, Img, PageLayout } from "../../styles/commonStyle";
import { cardTitleColor, modalGreyBtnColor, orangeColor2, primaryColor, spanBlueColor } from "../../styles/theme";
import { Tab } from "./style";
import iconJoin from "../../assets/images/icon-join.png";
import { Link } from "react-router-dom";

function RegisterCompletePage() {
  return (
    <PageLayout>
      <Font fontSize="1.5rem" fontWeight="600" color={cardTitleColor} changeFontSize="20px">
        evPlug 통합 회원가입 완료
      </Font>
      <Blank height="20px"></Blank>
      <Div className="flex flex-col justify-center items-center" style={{ border: '1px solid #e0e0e0', borderRadius: '8px', width: '100%', padding: '20px 0 80px 0'}}>
        <Blank height="calc(1rem + 2vw)"></Blank>
        <Img src={iconJoin} alt="joinIcon" width="calc(6rem + 2vw)" />
        <Blank height="calc(0.5rem + 0.5vw)"></Blank>
        <Font fontSize="calc(1rem + 1vw)" fontWeight="500" className="text-center">
          evPlug의 멤버가 되신 것을
          <br />
          환영합니다:)
        </Font>
        <Link to="/">
          <EvButton color="#FFF" bgColor={orangeColor2} className="mt-[4rem]" width="240px" fontSize="16px" >
            홈화면으로 이동
          </EvButton>
        </Link>
      </Div>
    </PageLayout>
  );
}

export default RegisterCompletePage;
